import '@fortawesome/fontawesome-free/css/all.min.css'
import "react-datetime/css/react-datetime.css";
import './styles/main.css'

import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { library } from '@fortawesome/fontawesome-svg-core'
import { QueryClient, QueryClientProvider } from 'react-query';
import { AppService } from 'web/AppService';
import { App } from './App';
import { User } from './model/User';
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Theme } from 'react-daisyui'
import * as Sentry from "@sentry/react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import Cookies from 'js-cookie';
import { configureAnalyticsTelemetry, trackAnalyticsEvent } from './utils/analyticsTelemetry';

const BASE_URL = ''

library.add(fas)

const container = document.getElementById('root')
const root = createRoot(container!)

const queryClient = new QueryClient({
    defaultOptions: {
    },
})

const preRenderPromise = (window as any).INIT_USER ?
    Promise.resolve((window as any).INIT_USER) :
    fetch('/api/token-auth/me')
        .then(response => response.json());

preRenderPromise.then(data => {
    (window as any).INIT_USER = data
    const organizationId = Cookies.get('nx-org');

    TagManager.initialize({
        gtmId: 'GTM-PRSBPGWD',
        dataLayer: {
            userId: (window as any).INIT_USER.id,
            userEmail: (window as any).INIT_USER.email,
            organizationId,
            sendPageView: false,
        },
    });

    configureAnalyticsTelemetry({ organizationId, userId: (window as any).INIT_USER?.id });
    trackAnalyticsEvent('app_loaded');

    const initialUser = new User((window as any).INIT_USER)
    root.render(
        <QueryClientProvider client={queryClient}>
            <Theme dataTheme="light">
                <AppService baseUrl = {BASE_URL} initialUser={initialUser}
                    renderChildren={(appContext) => <App context={appContext} /> }/>
            </Theme>
        </QueryClientProvider>
    )
});

Sentry.init({
    dsn: "https://27ca6d436bd3814a3b76477b4c005390@o4507968713064448.ingest.us.sentry.io/4507969229029376",
    integrations: [
        Sentry.browserTracingIntegration(),
        // Sentry.replayIntegration(),  //TODO: Replay eats too much memory. Research a way to enable it only for specific users.
        Sentry.reactRouterV6BrowserTracingIntegration({
          useEffect: React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
    ],

    beforeSend(event) {
        const isLocalhost = window.location.hostname === 'localhost';
        return isLocalhost ? null : event;
    },

    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https:\/\/app.nx\.vet\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
